<template>
  <v-flex
     xs12
    align-self-center
    justify-center
  >
  <v-card>
    <v-card-text>
        <v-container fill-height fluid>
        <v-row>
          <v-flex xs3 class="mr-2">
            <SchoolSubjectSelect
              v-model="filters.subjectId"
              @change="fetchTeachers"
            />
          </v-flex>
          <v-flex xs3 class="mr-2">
            <PropagandistSelect
              v-model="filters.propagandistId"
              @change="fetchTeachers"
            />
          </v-flex>
          <v-flex xs3 class="mr-2">
            <SchoolTypeSelect
              v-model="filters.schoolTypeId"
              @change="fetchTeachers"
              :multiple="true"
            />
          </v-flex>
          <v-spacer></v-spacer>
        </v-row>
        </v-container>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          :server-items-length="totalItems"
          :no-data-text="$t('NO_DATA')"
          :no-results-text="$t('NO_DATA')"
          hide-default-footer
          :options.sync="pagination"
          :loading="loading"
          item-key="teacher.id"
          class="elevation-1"
          show-select
        >
          <template v-slot:[`item.teacher_fullname`]="{ item }">
                {{ item.teacher.fullname }}
          </template>

          <template v-slot:[`item.subjects.name`]="{ item }">
                {{ item.subject.name }}
          </template>

        </v-data-table>
        <Paginator
          :total-items="totalItems"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.itemsPerPage"
          @change="fetchTeachers"
        />
    </v-card-text>
    <v-card-actions>
        <v-btn @click="save" color="primary">{{ $t('SEND') }}</v-btn>
        <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>

  </v-flex>
</template>
<script>

  import { mapActions } from 'vuex';

  import { campaignsService } from '../../utils/services/campaigns.service';
  import { subjectsService } from '../../utils/services/subjects.service';
  import { communicationsService } from '../../utils/services/communications.service';
  import { propagandistsService } from '../../utils/services/propagandists.service';
  import { schoolsTypesService } from '../../utils/services/schoolsTypes.service';

  import PropagandistSelect from '../../components/shared/Vselects/PropagandistSelect.vue';
  import SchoolSubjectSelect from '../../components/shared/Vselects/SchoolSubjectSelect.vue';
  import SchoolTypeSelect from '../../components/shared/Vselects/SchoolTypeSelect.vue';
  import Paginator from '../../components/shared/Paginator';

  export default {
    name: 'CommunicationSend',
    components: { PropagandistSelect, SchoolSubjectSelect, SchoolTypeSelect, Paginator },
    data() {
      return {
        loading: false,
        items: [],
        selected: [],
        subjects: [],
        propagandists: [],
        schoolTypes: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['teacher_fullname'],
        },
        headers: [
          { text: this.$t('fields.teacher'), value: 'teacher_fullname' },
          { text: this.$t('fields.subject'), value: 'subjects.name' },
        ],
        filters: {
          subjectId: 0,
          schoolTypeId: [],
          propagandistId: 0,
        },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          subjectId: this.filters.subjectId,
          schoolTypeId: this.filters.schoolTypeId,
          propagandist: this.filters.propagandistId,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },

    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      save() {
          communicationsService.send(this.$router.currentRoute.params.id, {
            teachers: this.selected.map(x => x.teacher.id),
          })
          .then((response) => {
            this.showToast({ type: 'success', message: response.data.message });
            this.$router.push({ name: this.routeName.COMMUNICATION });
          })
          .catch(error => {
                this.handleError(error, this.errors);
          });
      },

      cancel() {
        this.$router.push({ name: this.routeName.COMMUNICATION });
      },

      fetchSubjects() {
        return subjectsService.index({
          filters: {
            sortBy: ['name'],
            sortDesc: [true],
          },
        })
        .then(response => {
            this.subjects = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      fetchPropagandist() {
        return propagandistsService.index({
          filters: {
            sortBy: ['name'],
            sortDesc: [true],
          },
        })
        .then(response => {
            this.propagandists = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      fetchSchoolTypes() {
        return schoolsTypesService.index({
            filters: {
              sortBy: ['name'],
              sortDesc: [true],
            },
          })
        .then(response => {
            this.schoolTypes = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchCampaigns(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return campaignsService.schoolResultIndex({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      async fetchTeachers(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return subjectsService.teachers(this.filters.subjectId, {
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
    async created() {
      this.fetchSubjects();
      this.fetchPropagandist();
      this.fetchSchoolTypes();
      this.fetchTeachers(1);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchTeachers(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchTeachers(1);
          }
        },
      },
    },
  };
</script>
